import React, { useEffect } from 'react'
import PageWrapper from 'Pages/@PageWrapper'
import { ADMIN_ROUTES } from '@constants'
import { clearSignals } from 'Pages/Admin/GlobalExecution/@signals'
import AdminGlobalExecutionTabs from 'Pages/Admin/GlobalExecution/Tabs'
import GlobalExecutionReportsBlock from './Reports'
import GlobalExecutionScrapersBlock from './Scrapers'
import GlobalExecutionBatchesBlock from "./Batches";
import RunningSearchesModal, { RunningSearchesInfoButton } from './RunningSearchesModal'

export default function GlobalExecutionAdminPage() {

	useEffect(() => {
		clearSignals()
		return () => {
			clearSignals()
		}
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.GLOBAL_EXECUTION_SUBTITLE}
		isEmpty={false}
		actions={<RunningSearchesInfoButton />}
	>
		<AdminGlobalExecutionTabs/>
		<GlobalExecutionReportsBlock />
		<GlobalExecutionScrapersBlock />
		<GlobalExecutionBatchesBlock />
		<RunningSearchesModal />
	</PageWrapper>
}